import React, { useEffect } from "react";
import logo from "../assets/pos.png";
import "../App.css";
import { motion } from "framer-motion";

const About = () => {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // 🔹 Animation variants
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8 }
    }
  };

  return (
    <div>
      <div className="container about-container pt-lg-5">

        <motion.div className="about-title"   variants={fadeUp}
          initial="hidden"
          animate="visible">INTRODUCTION TO POTHYS </motion.div>

        <div className="about-text">

            {[`
                The house of Pothys has a rich legacy and vibrant history, our founding fathers served as weavers to the royal households of the maharajas of yesteryears. Pothys itself was established over 90 years back by K.V. Pothy Moopanar, our founding father, under the name Pothy Moopanar to sell cotton sarees, dhotis and towels woven in his own loom.
                `,
                `
                Thus, our first showroom was set up at Srivilliputtur. Like all great success stories, Pothys as the shop is fondly called by customers, began from humble origins and established itself as a household name in the textile industry in Tamil Nadu. Our undisputed reputation stems from our unflinching dedication to give you the highest quality, exclusive and diverse clothing options and unmatched customer service.
                 `,
                `
                Our hard work, dedication and perseverance has earned us the distinction of being voted the most preferred saree showroom in Chennai, According to SUN TV Neilson survey in the year 2002. We are also the first retail showroom in Tamil Nadu to be accredited with ISO 9001 certification way back in 2003. Pothys desire to innovate and excel in silk manufacturing won us the Guinness World Record in the year 2005 for creating the world's longest silk saree.
                `,
                `
                Pothys houses the largest collection of silk sarees in Tamil Nadu, offering customers an unparalleled range of diverse silk varieties, exclusive designs, and authentic silk brands. We take pride in being the first textile showroom in Tamil Nadu to launch our own unique brands of silk sarees Samudrika, Parampara, and Vastrakala. These exclusive collections are renowned for their opulent silk quality, exquisite designs, genuine zari work, and masterful weaving artistry, delivering a luxurious look and feel. Each saree from our branded collections is a true heirloom, crafted to be cherished and passed down through generations.
                `
            ].map((text, i) => (
                <motion.p
                key={i}
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                >
                {text}
                </motion.p>
            ))}



          <motion.h4 variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>Pothys Groups</motion.h4>
          <motion.ul variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            <li>Pothys Textiles</li>
            <li>OTTO</li>
            <li>Minister White</li>
            <li>Pothys Mart</li>
            <li>Natchiyar, from the House of Pothysmart</li>
            <li>Pothys Swarna Mahal</li>
          </motion.ul>

          <motion.h4 variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>Pothys Swarna Mahal</motion.h4>
          <motion.p variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            Expanding our legacy of excellence, Pothys has ventured into the prestigious jewellery industry with the launch of Pothys Swarna Mahal. Our journey began with the opening of our first flagship jewellery store in Tirunelveli in July 2021, followed by showrooms in Chromepet (August 2021), Trivandrum (December 2022), Tiruchirappalli (December 2023), Coimbatore (July 2024), Salem (April 2025), Poonamallee (October 2025) and Padi (December 2025).
          </motion.p>

          <motion.p variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            At Pothys, we remain committed to delivering unmatched quality, artistry, and customer satisfaction, whether in textiles or fine jewellery.
          </motion.p>

          <motion.p variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}><strong>Our Vision:</strong> To be the “Most Trusted Jeweller of South India”</motion.p>
          <motion.p variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}><strong>Our Mission:</strong> To achieve the status of “The Most Trusted Jeweller of South India” by providing uncompromised quality, a wide range of designs from all around the globe, hospitality at its best, and all at the right price.</motion.p>
          <motion.p variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}><strong>Our Values:</strong> "More for Less" has been Pothys Swarna Mahal's value proposition since its inception, and we always strive to create more value for our customers across all our products and services.</motion.p>

          <motion.h4 variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>Awards & Accolades</motion.h4>
          <motion.ul variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            <li><strong>2022:</strong>
              <motion.ul variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
                <li>“Bridal Gold Jewellery of the Year” by the Gem and Jewellery Council of India.</li>
                <li>“The best promotional campaign of the year”</li>
                <li>“PGI Season of LOVE Platinum Award” - 1st Runner Up in Best Independent Store in South India for platinum jewellery sales.</li>
              </motion.ul>
            </li>
            <li><strong>2023:</strong> “Bridal Gold Jewellery of the Year” by the Gem and Jewellery Council of India.</li>
            <li><strong>2025:</strong> “Jewellery Brand of the Year 2025” by The Economic Times Great India Retail Awards.</li>
          </motion.ul>

          <motion.p variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            At PSM, we are driven by a shared commitment to excellence, innovation, and integrity. Our culture is built on collaboration, continuous growth, and mutual respect—empowering each team member to thrive and contribute meaningfully.
          </motion.p>

          <motion.p variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            Our ambitious growth plan is to set up more stores in India and abroad to serve our valued customers more efficiently.
          </motion.p>

          <motion.p variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
            We welcome you to be part of our journey and look forward to achieving great success together!
          </motion.p>

        </div>
      </div>
    </div>
  );
};

export default About;